import type { TerraUIMessage } from '@terra/shared-dto-chat-types';
import { finalizeStreamingChatPart } from './finalize-streaming-chat-parts';

const isIncompleteStreamTextPart = (part: TerraUIMessage['parts'][number]) =>
  (part.type === 'text' || part.type === 'reasoning') &&
  part.state === 'streaming';

export const prepareMessagesForChatStreamResume = (
  messages: TerraUIMessage[],
): TerraUIMessage[] => {
  const lastMessage = messages.at(-1);

  if (!lastMessage || lastMessage.role !== 'assistant' || !lastMessage.parts) {
    return messages;
  }

  return [
    ...messages.slice(0, -1),
    {
      ...lastMessage,
      parts: lastMessage.parts
        .filter((part) => !isIncompleteStreamTextPart(part))
        .map((part) => finalizeStreamingChatPart(part)),
    },
  ];
};
